<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>Identity Document Help</h2>
    <button mat-icon-button fxLayoutAlign="end center" (click)="close()">
        <mat-icon aria-label="Close" class="headerIconButton">close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialogContent">
    <mat-card class="profileCard">
        <mat-card-content class="mainStepperCardContent" style="background: #f2f2f2;">
            <mat-card class="stepperCard">
                <mat-card-header>
                    <mat-card-title>Details</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div fxLayout="column">
                        <div fxLayout="row">
                            <p>Before uploading your Identity document information, make sure to follow these instructions - it is essential that the copies you send us are of high quality:</p>
                        </div>
                        <div fxLayout="row" fxFlex="100%" class="liRow">
                            <ul class="marginTop0">
                                <li>Upload a copy of your Passport: a driving license is not a valid travel document and will not be accepted.</li>
                                <li>Upload a scanned version of your document. If you must provide a picture, make sure your document is laid out on a flat surface, and all details are clearly visible.</li>
                                <li>Picture showing fingers or other objects will be rejected.</li>
                                <li>A cropped picture of your passport will be rejected, make sure the file you upload shows all parts of your passport – the upload tool allows you to crop and move the image around to fit the window.</li>
                                <li>Make sure the file you upload is not blurry and properly displays your passport.</li>
                                <li>The system accepts all common image formats (jpg, jpeg, png etc.)</li>
                                <li>Please make sure the passport ID page you provide fits in the box: images that are too small will be rejected.</li>
                            </ul>
                        </div>
                        <div fxLayout="row" fxFlex="100%" class="liRow">
                            <p class="wordBreak">For any question or concern, please contact the Immigration Services Office at <a href="mailto:immigrationservices@johncabot.edu" target="_top">immigrationservices@johncabot.edu</a>.</p>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>Samples</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="column">
                            <!--<div fxLayout="row" fxFlex="100%" class="liRow">
                                <p>Passport - United States</p>
                            </div>-->
                            <div fxLayout="row" fxFlex="100%">
                                <img title="Passport - USA" src="./assets/passport usa.png" alt="Passport - USA" width="95%" height="90%" class="center">
                            </div>
                            <!--<div fxLayout="row" fxFlex="100%" class="liRow">
                                <p>Passport - Rest of World</p>
                            </div>-->
                            <div fxLayout="row" fxFlex="100%">
                                <img title="Passport - Rest of World" src="./assets/passport row.png" alt="Passport - Rest of World" width="95%" height="90%" class="center">
                            </div>
                            <!--<div fxLayout="row" fxFlex="100%" class="liRow">
                                <p>Italian Identity Card</p>
                            </div>-->
                            <div fxLayout="row" fxFlex="100%">
                                <img title="Italian Identity Card" src="./assets/italian id.png" alt="Italian Identity Card" width="95%" height="90%" class="center">
                            </div>
                            <!--<div fxLayout="row" fxFlex="100%" class="liRow">
                                <p>European Identity Card</p>
                            </div>-->
                            <div fxLayout="row" fxFlex="100%">
                                <img title="European Identity Card" src="./assets/european id.png" alt="European Identity Card" width="95%" height="90%" class="center">
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </mat-card>
        </mat-card-content>
        <mat-divider class="dividerColor"></mat-divider>
        <mat-card-actions fxLayoutAlign="end center">
            <button class="mat-raised-button dialogActionButton" mat-button color="primary" (click)="close()" type="button">Close</button>
        </mat-card-actions>
    </mat-card>
</mat-dialog-content>
